import { ReactNode } from 'react';
import { GridRowParams } from '@rossum/ui/x-data-grid-pro';
import { SelectAnnotationParams } from '../document-list-base/supportedAnnotationViews';
import { TypedGridColDef } from '../document-list-columns/TypedGridColDef';
import { RestrictedAccessIcon } from '../pricing/components/RestrictedAccessIcon';
import { RowActions } from './components/RowActions';
import { AllDocsAnnotation } from './types';

const ACTIONS_COLUMN = 'actions';

// action column is not defined in the API because it is purely for FE and does not relate to any data in the API
// which is why have to separate it from meta columns that are defined in the API.

export const createActionsColumn = ({
  handleSelectAnnotation,
  header,
}: {
  handleSelectAnnotation: (params: SelectAnnotationParams) => void;
  header?: ReactNode;
}): TypedGridColDef<AllDocsAnnotation> => ({
  field: ACTIONS_COLUMN,
  type: 'actions',
  width: 50,
  resizable: false,
  sortable: false,
  disableColumnMenu: true,
  disableReorder: true,
  headerAlign: 'center',
  renderHeader: () => header,
  operators: [],
  filterable: false,
  getActions: ({ row, id }: GridRowParams<AllDocsAnnotation>) => [
    row.restricted_access ? (
      // oxlint-disable-next-line react/jsx-key -- oxlint stricter than eslint — conditional branch in array
      <RestrictedAccessIcon />
    ) : (
      <RowActions
        key={id}
        annotation={row}
        handleSelectAnnotation={handleSelectAnnotation}
      />
    ),
  ],
});
